var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgToastErrorinline = function SvgToastErrorinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.326 17.493 13.831 4.476a2.123 2.123 0 0 0-3.66 0L2.676 17.493a2.015 2.015 0 0 0 0 2.033 2.087 2.087 0 0 0 1.83 1.045h14.99a2.089 2.089 0 0 0 1.828-1.045 2.015 2.015 0 0 0 .002-2.033Zm-10.01-7.207a.686.686 0 0 1 1.37 0v3.428a.685.685 0 1 1-1.37 0v-3.428ZM12 17.828a1.028 1.028 0 1 1 0-2.055 1.028 1.028 0 0 1 0 2.055Z",
    fill: "#FD4F4F"
  })));
};
export default SvgToastErrorinline;